{
  "custom": {
    "hours": {
      "floatingExceptionSummary": "$t(ixfHoursV1:enum.IxfHoursV1WeekOfMonth.{{weekOfMonth}}) $t(ixfHoursV1:enum.IxfHoursV1DayOfWeek.{{dayOfWeek}}) of {{month}}"
    }
  }
}